export default "/images/vendor/flag-icon-css/flags/4x3/pn.svg?714032582a0c72e2f95497243ad9f536";